import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "v-users" }
const _hoisted_2 = { class: "v-users__header" }
const _hoisted_3 = { class: "v-users__tabs" }
const _hoisted_4 = { class: "v-users__header--right" }
const _hoisted_5 = { class: "v-users__badge" }
const _hoisted_6 = {
  key: 0,
  class: "v-users__actions"
}
const _hoisted_7 = ["onClick"]
const _hoisted_8 = ["onClick"]
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { key: 1 }
const _hoisted_11 = {
  key: 1,
  class: "team"
}
const _hoisted_12 = { class: "team__item--shift" }
const _hoisted_13 = { class: "title" }
const _hoisted_14 = { class: "info" }
const _hoisted_15 = { class: "icon" }
const _hoisted_16 = { class: "name" }
const _hoisted_17 = { class: "role" }
const _hoisted_18 = { class: "label" }
const _hoisted_19 = { class: "name" }
const _hoisted_20 = { class: "role" }
const _hoisted_21 = { class: "v-users__form" }
const _hoisted_22 = { style: {"display":"flex","justify-content":"space-between"} }
const _hoisted_23 = { style: {"display":"flex","justify-content":"space-between"} }
const _hoisted_24 = { style: {"display":"flex","justify-content":"space-between"} }
const _hoisted_25 = { style: {"display":"flex","justify-content":"space-between"} }
const _hoisted_26 = { style: {"display":"flex","justify-content":"space-between","gap":"16px"} }
const _hoisted_27 = { style: {"display":"flex","justify-content":"space-between","gap":"16px"} }
const _hoisted_28 = { style: {"display":"flex","justify-content":"flex-end","width":"100%","gap":"16px"} }
const _hoisted_29 = { class: "v-users__form" }
const _hoisted_30 = { style: {"display":"flex","justify-content":"flex-end","width":"100%","gap":"16px"} }
const _hoisted_31 = { class: "new-modal" }
const _hoisted_32 = { class: "description__footer" }

import { computed, onMounted, ref, watch } from "vue";
import CommonButton from "@/components/common/CommonButton.vue";
import CommonDropdown from "@/components/common/CommonDropdown.vue";
import CommonInput from "@/components/common/CommonInput.vue";
import CommonSearch from "@/components/common/CommonSearch.vue";
import CommonTable from "@/components/common/CommonTable.vue";
import CommonModal from "@/components/common/CommonModal.vue";
import { useUserStore } from "@/features/users/user.store";
import { useShiftStore } from "@/features/shifts/shifts.store";
import { useTeamStore } from "@/features/teams/team.store";
import { useNotification } from "@/utils/notification";
import { IUser } from "@/features/users/user.types";
import { IShiftTemplate } from "@/features/shifts/shifts.types";
import { ITeam } from "@/features/teams/team.types";
import {
  Pencil02,
  Plus,
  SearchMd,
  Trash01,
  Users03,
  Lock01,
} from "utruckin-icons";
import router from "@/router";


export default /*@__PURE__*/_defineComponent({
  __name: 'UsersView',
  setup(__props) {

const userStore = useUserStore();
const shiftStore = useShiftStore();
const teamStore = useTeamStore();
const { pushNotification } = useNotification();

const loading = ref(false);
const users = ref<IUser[]>([]);
const shifts = ref<IShiftTemplate[]>([]);
const teams = ref<ITeam[]>([]);

// ─── FILTERS ─────────────────────────────────────────────
const searchQuery = ref("");
const role = ref<string | null>(null);
const team = ref<string | null>(null);
const activeTab = ref<"users" | "graphic" | "team">("users");

let filterTimeout: ReturnType<typeof setTimeout> | null = null;

const roleItems = computed(() => {
  if (
    userStore.userProfile?.role == "admin" ||
    userStore.userProfile?.role == "super_admin"
  ) {
    return [
      { value: "worker", name: "Specialist" },
      { value: "supervisor", name: "Supervisor" },
      { value: "admin", name: "Admin" },
    ];
  } else {
    return [
      { value: "worker", name: "Specialist" },
      { value: "supervisor", name: "Supervisor" },
    ];
  }
});

const dayOffItems = [
  { value: "MON", name: "Monday" },
  { value: "TUE", name: "Tuesday" },
  { value: "WED", name: "Wednesday" },
  { value: "THU", name: "Thursday" },
  { value: "FRI", name: "Friday" },
  { value: "SAT", name: "Saturday" },
  { value: "SUN", name: "Sunday" },
];

const teamItems = computed(() =>
  teams.value.map((t) => ({ value: t.id, name: t.name }))
);

const shiftItems = computed(() =>
  shifts.value.map((s) => ({ value: String(s.id), name: s.title }))
);

// ─── USERS TAB ───────────────────────────────────────────
const getTeamName = (teamId: string | null): string => {
  if (!teamId) return "—";
  const found = teams.value.find((t) => t.id === teamId);
  return found?.name || "—";
};

const getRoleName = (role: string) => {
  if (!role) return "-";
  if (role == "admin") return "Admin";
  if (role == "supervisor") return "Supervisor";
  if (role == "worker") return "Specialist";
};

const tableGroups = computed(() => {
  const groups = shifts.value.map((shift) => ({
    label: shift.title,
    items: users.value
      .filter((user) => Number(user.shift_template_id) === Number(shift.id))
      .sort((a, b) => (a.team_name || "").localeCompare(b.team_name || "")),
  }));
  const withoutShift = users.value.filter((user) => !user.shift_template_id);
  if (withoutShift.length) {
    groups.push({ label: "Admin", items: withoutShift });
  }
  return groups;
});

const teamGroups = computed(() => {
  return shifts.value.map((shift) => {
    const shiftUsers = users.value.filter(
      (user) => Number(user.shift_template_id) === Number(shift.id)
    );

    const admins = shiftUsers.filter((user) => user.role === "supervisor");

    const items = teams.value
      .map((team) => ({
        label: team.name,
        items: shiftUsers.filter(
          (user) => user.role !== "supervisor" && user.team_id === team.id
        ),
      }))
      .filter((team) => team.items.length);

    return {
      label: shift.title,
      admins,
      items,
      count: shiftUsers.length,
    };
  });
});

const isAdmin = computed(() => {
  return (
    userStore.userProfile?.role == "admin" ||
    userStore.userProfile?.role == "super_admin" ||
    userStore.userProfile?.role == "supervisor"
  );
});

// ─── DELETE ──────────────────────────────────────────────
const deleteUser = async (id: string) => {
  await userStore.deactivateUser(loading, id);
  pushNotification("User deleted successfully", "success");
  users.value = await userStore.getUsers(loading);
};

// ─── ADD MODAL ───────────────────────────────────────────
const addModal = ref(false);
const addLoading = ref(false);
const addTouched = ref(false);

const addForm = ref({
  first_name: "",
  last_name: "",
  email: "",
  password: "",
  phone_number: "",
  role: "",
  team_id: "",
  shift_template_id: "",
  monthly_wage: "",
  date_of_birth: "",
  working_since: "",
  default_day_off: "",
  is_active: true,
});

const addErrors = computed(() => ({
  first_name: addTouched.value && !addForm.value.first_name.trim(),
  last_name: addTouched.value && !addForm.value.last_name.trim(),
  email: addTouched.value && !addForm.value.email.trim(),
  password: addTouched.value && addForm.value.password.trim().length < 8,
}));

const passwordError = computed(() => {
  return addForm.value.password.trim()
    ? addForm.value.password.trim().length < 8
      ? "Password must be at least 8"
      : ""
    : "Password is required";
});

const openAddModal = () => {
  addTouched.value = false;
  addForm.value = {
    first_name: "",
    last_name: "",
    email: "",
    password: "",
    phone_number: "",
    role: "",
    team_id: "",
    shift_template_id: "",
    monthly_wage: "",
    date_of_birth: "",
    working_since: "",
    default_day_off: "",
    is_active: true,
  };
  addModal.value = true;
};

const submitAdd = async () => {
  addTouched.value = true;
  if (
    !addForm.value.first_name.trim() ||
    !addForm.value.last_name.trim() ||
    !addForm.value.email.trim() ||
    !addForm.value.password.trim() ||
    addForm.value.password.trim().length < 8
  )
    return;

  const organizationId: string = localStorage.getItem(
    "organizationId"
  ) as string;
  if (!organizationId) router.push("/organization");

  const payload: any = {
    name: addForm.value.first_name + " " + addForm.value.last_name,
    email: addForm.value.email,
    password: addForm.value.password,
    phone_number: addForm.value.phone_number || null,
    role: addForm.value.role,
    is_active: addForm.value.is_active,
    monthly_wage: addForm.value.monthly_wage,
    date_of_birth: addForm.value.date_of_birth,
    working_since: addForm.value.working_since,
    default_day_off: addForm.value.default_day_off || null,
    ...(addForm.value.team_id ? { team_id: addForm.value.team_id } : {}),
    ...(addForm.value.shift_template_id
      ? { shift_template_id: Number(addForm.value.shift_template_id) }
      : {}),
    organization_id: organizationId,
  };
  const result = await userStore.createUser(addLoading, payload);
  if (result?.id) {
    pushNotification("User created successfully", "success");
    users.value = await userStore.getUsers(loading);
    addModal.value = false;
  }
};

// ─── EDIT MODAL ──────────────────────────────────────────
const editModal = ref(false);
const editLoading = ref(false);
const editTouched = ref(false);
const editUserId = ref<string>("");

const editForm = ref({
  first_name: "",
  last_name: "",
  email: "",
  phone_number: "",
  role: "",
  default_day_off: "",
  team_id: "",
  shift_template_id: "",
  is_active: true,
});

const editErrors = computed(() => ({
  first_name: editTouched.value && !editForm.value.first_name.trim(),
  last_name: editTouched.value && !editForm.value.last_name.trim(),
  email: editTouched.value && !editForm.value.email.trim(),
}));

const openEditModal = (item: IUser) => {
  editTouched.value = false;
  editUserId.value = item.id;
  editForm.value = {
    first_name: item.name.split(" ")[0],
    last_name: item.name.split(" ")[1],
    email: item.email,
    phone_number: item.phone_number || "",
    role: item.role,
    default_day_off: item.default_day_off || "",
    team_id: item.team_id || "",
    shift_template_id: item.shift_template_id
      ? String(item.shift_template_id)
      : "",
    is_active: item.is_active,
  };
  editModal.value = true;
};

const submitEdit = async () => {
  editTouched.value = true;
  if (
    !editForm.value.first_name.trim() ||
    !editForm.value.last_name.trim() ||
    !editForm.value.email.trim()
  )
    return;

  const payload: any = {
    name: editForm.value.first_name + " " + editForm.value.last_name,
    email: editForm.value.email,
    phone_number: editForm.value.phone_number || null,
    role: editForm.value.role,
    is_active: editForm.value.is_active,
    ...(editForm.value.default_day_off
      ? { default_day_off: editForm.value.default_day_off }
      : {}),
    ...(editForm.value.team_id ? { team_id: editForm.value.team_id } : {}),
    ...(editForm.value.shift_template_id
      ? { shift_template_id: Number(editForm.value.shift_template_id) }
      : {}),
  };

  const result = await userStore.updateUserProfile(
    editLoading,
    editUserId.value,
    payload
  );
  if (result?.id) {
    pushNotification("User updated successfully", "success");
    users.value = await userStore.getUsers(loading);
    editModal.value = false;
  }
};

// password modal

const password = ref<string>("");
const confirmPassword = ref<string>("");
const passwordModal = ref<boolean>(false);
const passwordLoading = ref<boolean>(false);
const passwordUserId = ref<string>("");

const openPasswordModal = (id: string) => {
  password.value = "";
  confirmPassword.value = "";
  passwordModal.value = true;
  passwordUserId.value = id;
};

const closePasswordModal = () => {
  password.value = "";
  confirmPassword.value = "";
  passwordModal.value = false;
  passwordUserId.value = "";
  searchQuery.value = "";
};

const savePasswordModal = async () => {
  if (!(password.value.length > 5) || password.value !== confirmPassword.value)
    return;

  const result = await userStore.changePassword(
    passwordLoading,
    passwordUserId.value,
    {
      new_password: password.value,
    }
  );

  if (result) {
    pushNotification("Password changed successfully", "success");
    closePasswordModal();
  }
};

onMounted(async () => {
  const shiftLoading = ref(false);
  const usersLoading = ref(false);
  const teamLoading = ref(false);

  [users.value, shifts.value, teams.value] = await Promise.all([
    userStore.getUsers(usersLoading),
    shiftStore.getShifts(shiftLoading),
    teamStore.getTeams(teamLoading),
  ]);

  if (userStore.commonFilter.q) {
    searchQuery.value = userStore.commonFilter.q;
  }

  if (userStore.commonFilter.role) {
    role.value = userStore.commonFilter.role;
  }

  if (userStore.commonFilter.team_id) {
    team.value = userStore.commonFilter.team_id;
  }
});

watch([searchQuery, role, team], () => {
  if (filterTimeout) clearTimeout(filterTimeout);
  filterTimeout = setTimeout(async () => {
    userStore.commonFilter.q = searchQuery.value;
    userStore.commonFilter.role = role.value ?? "";
    userStore.commonFilter.team_id = team.value ?? "";
    users.value = await userStore.getUsers(loading);
  }, 300);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("button", {
          class: _normalizeClass(["v-users__tab", { active: activeTab.value === 'users' }]),
          onClick: _cache[0] || (_cache[0] = ($event: any) => (activeTab.value = 'users'))
        }, " Users ", 2),
        _createElementVNode("button", {
          class: _normalizeClass(["v-users__tab", { active: activeTab.value === 'team' }]),
          onClick: _cache[1] || (_cache[1] = ($event: any) => (activeTab.value = 'team'))
        }, " Team ", 2)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(CommonSearch, {
          modelValue: searchQuery.value,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((searchQuery).value = $event)),
          icon: _unref(SearchMd),
          placeholder: "Search",
          clearable: ""
        }, null, 8, ["modelValue", "icon"]),
        _createVNode(CommonDropdown, {
          modelValue: role.value,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((role).value = $event)),
          items: roleItems.value,
          label: "Role",
          clearable: ""
        }, null, 8, ["modelValue", "items"]),
        _createVNode(CommonDropdown, {
          modelValue: team.value,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((team).value = $event)),
          items: teamItems.value,
          label: "Team",
          clearable: ""
        }, null, 8, ["modelValue", "items"]),
        (isAdmin.value)
          ? (_openBlock(), _createBlock(CommonButton, {
              key: 0,
              type: "primary",
              label: "Add User",
              prepend: true,
              prependIcon: _unref(Plus),
              onClicked: openAddModal
            }, null, 8, ["prependIcon"]))
          : _createCommentVNode("", true)
      ])
    ]),
    (activeTab.value === 'users')
      ? (_openBlock(), _createBlock(CommonTable, {
          key: 0,
          headers: _unref(userStore).userHeaders,
          groups: tableGroups.value,
          loading: loading.value
        }, {
          id: _withCtx(({ index }) => [
            _createElementVNode("span", null, _toDisplayString(index + 1), 1)
          ]),
          title: _withCtx(({ item }) => [
            _createElementVNode("span", null, _toDisplayString(item.name), 1)
          ]),
          role: _withCtx(({ item }) => [
            _createElementVNode("span", _hoisted_5, _toDisplayString(getRoleName(item.role)), 1)
          ]),
          team: _withCtx(({ item }) => [
            _createElementVNode("span", null, _toDisplayString(getTeamName(item.team_id)), 1)
          ]),
          off_day: _withCtx(({ item }) => [
            _createElementVNode("span", null, _toDisplayString(item.default_day_off || "—"), 1)
          ]),
          actions: _withCtx(({ item }) => [
            (isAdmin.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _createElementVNode("button", {
                    class: "v-users__btn",
                    onClick: ($event: any) => (openEditModal(item))
                  }, [
                    _createVNode(_unref(Pencil02), { size: 18 })
                  ], 8, _hoisted_7),
                  _createElementVNode("button", {
                    class: "v-users__btn",
                    onClick: ($event: any) => (deleteUser(item.id))
                  }, [
                    _createVNode(_unref(Trash01), { size: 18 })
                  ], 8, _hoisted_8),
                  (isAdmin.value)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        class: "v-users__btn",
                        onClick: ($event: any) => (openPasswordModal(item.id))
                      }, [
                        _createVNode(_unref(Lock01), { size: 18 })
                      ], 8, _hoisted_9))
                    : _createCommentVNode("", true)
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_10, "-"))
          ]),
          _: 1
        }, 8, ["headers", "groups", "loading"]))
      : _createCommentVNode("", true),
    (activeTab.value === 'team')
      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(teamGroups.value, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "team__item",
              key: index
            }, [
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, _toDisplayString(item.label), 1),
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("div", _hoisted_15, [
                    _createVNode(_unref(Users03), { size: 20 })
                  ]),
                  _createElementVNode("span", null, _toDisplayString(item.count), 1)
                ])
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.admins, (admin, admIndex) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: admIndex,
                  class: "team__item--admin"
                }, [
                  _createElementVNode("div", _hoisted_16, _toDisplayString(admin.name), 1),
                  _createElementVNode("div", _hoisted_17, _toDisplayString(admin.role), 1)
                ]))
              }), 128)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.items, (team, teamIndex) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: teamIndex,
                  class: "team__group"
                }, [
                  _createElementVNode("div", _hoisted_18, _toDisplayString(team.label), 1),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(team.items, (user, userIndex) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: userIndex,
                      class: "team__group--item"
                    }, [
                      _createElementVNode("div", _hoisted_19, _toDisplayString(user.name), 1),
                      _createElementVNode("div", _hoisted_20, _toDisplayString(user.role == "worker" ? "Specialist" : user.role), 1)
                    ]))
                  }), 128))
                ]))
              }), 128))
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    _createVNode(CommonModal, {
      modelValue: addModal.value,
      "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((addModal).value = $event)),
      title: "Add user"
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_28, [
          _createVNode(CommonButton, {
            type: "outline",
            label: "Cancel",
            onClicked: _cache[17] || (_cache[17] = ($event: any) => (addModal.value = false))
          }),
          _createVNode(CommonButton, {
            type: "primary",
            label: "Save",
            loading: addLoading.value,
            onClicked: submitAdd
          }, null, 8, ["loading"])
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_21, [
          _createElementVNode("div", _hoisted_22, [
            _createVNode(CommonInput, {
              modelValue: addForm.value.last_name,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((addForm.value.last_name) = $event)),
              label: "Last name",
              error: addErrors.value.last_name,
              errorMessage: "Last name is required",
              width: "calc(50% - 8px)"
            }, null, 8, ["modelValue", "error"]),
            _createVNode(CommonInput, {
              modelValue: addForm.value.first_name,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((addForm.value.first_name) = $event)),
              label: "First name",
              error: addErrors.value.first_name,
              errorMessage: "First name is required",
              width: "calc(50% - 8px)"
            }, null, 8, ["modelValue", "error"])
          ]),
          _createElementVNode("div", _hoisted_23, [
            _createVNode(CommonInput, {
              modelValue: addForm.value.email,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((addForm.value.email) = $event)),
              label: "Email",
              type: "email",
              error: addErrors.value.email,
              errorMessage: "Email is required",
              autocomplete: "email",
              width: "calc(50% - 8px)"
            }, null, 8, ["modelValue", "error"]),
            _createVNode(CommonInput, {
              modelValue: addForm.value.password,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((addForm.value.password) = $event)),
              label: "Password",
              type: "password",
              error: addErrors.value.password,
              errorMessage: passwordError.value,
              width: "calc(50% - 8px)"
            }, null, 8, ["modelValue", "error", "errorMessage"])
          ]),
          _createElementVNode("div", _hoisted_24, [
            _createVNode(CommonInput, {
              modelValue: addForm.value.monthly_wage,
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((addForm.value.monthly_wage) = $event)),
              label: "Monthly Wage",
              width: "calc(50% - 8px)"
            }, null, 8, ["modelValue"]),
            _createVNode(CommonInput, {
              modelValue: addForm.value.phone_number,
              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((addForm.value.phone_number) = $event)),
              label: "Phone number",
              width: "calc(50% - 8px)"
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_25, [
            _createVNode(CommonInput, {
              mask: "####-##-##",
              modelValue: addForm.value.date_of_birth,
              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((addForm.value.date_of_birth) = $event)),
              label: "Date of birth (YYYY-MM-DD)",
              width: "calc(50% - 8px)"
            }, null, 8, ["modelValue"]),
            _createVNode(CommonInput, {
              mask: "####-##-##",
              modelValue: addForm.value.working_since,
              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((addForm.value.working_since) = $event)),
              label: "Working since (YYYY-MM-DD)",
              width: "calc(50% - 8px)"
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_26, [
            _createVNode(CommonDropdown, {
              modelValue: addForm.value.role,
              "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((addForm.value.role) = $event)),
              items: roleItems.value,
              label: "Role",
              fullWidth: true
            }, null, 8, ["modelValue", "items"]),
            _createVNode(CommonDropdown, {
              modelValue: addForm.value.team_id,
              "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((addForm.value.team_id) = $event)),
              items: teamItems.value,
              label: "Team",
              fullWidth: true
            }, null, 8, ["modelValue", "items"])
          ]),
          _createElementVNode("div", _hoisted_27, [
            _createVNode(CommonDropdown, {
              modelValue: addForm.value.shift_template_id,
              "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((addForm.value.shift_template_id) = $event)),
              items: shiftItems.value,
              label: "Shift",
              fullWidth: true
            }, null, 8, ["modelValue", "items"]),
            _createVNode(CommonDropdown, {
              modelValue: addForm.value.default_day_off,
              "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((addForm.value.default_day_off) = $event)),
              items: dayOffItems,
              label: "Day off",
              fullWidth: true
            }, null, 8, ["modelValue"])
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(CommonModal, {
      modelValue: editModal.value,
      "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((editModal).value = $event)),
      title: "Edit user"
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_30, [
          _createVNode(CommonButton, {
            type: "outline",
            label: "Cancel",
            onClicked: _cache[27] || (_cache[27] = ($event: any) => (editModal.value = false))
          }),
          _createVNode(CommonButton, {
            type: "primary",
            label: "Save",
            loading: editLoading.value,
            onClicked: submitEdit
          }, null, 8, ["loading"])
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_29, [
          _createVNode(CommonInput, {
            modelValue: editForm.value.last_name,
            "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((editForm.value.last_name) = $event)),
            label: "Last name",
            error: editErrors.value.last_name,
            errorMessage: "Last name is required"
          }, null, 8, ["modelValue", "error"]),
          _createVNode(CommonInput, {
            modelValue: editForm.value.first_name,
            "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((editForm.value.first_name) = $event)),
            label: "First name",
            error: editErrors.value.first_name,
            errorMessage: "First name is required"
          }, null, 8, ["modelValue", "error"]),
          _createVNode(CommonInput, {
            modelValue: editForm.value.email,
            "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((editForm.value.email) = $event)),
            label: "Email",
            type: "email",
            error: editErrors.value.email,
            errorMessage: "Email is required",
            disabled: _unref(userStore).userProfile?.role !== 'super_admin'
          }, null, 8, ["modelValue", "error", "disabled"]),
          _createVNode(CommonInput, {
            modelValue: editForm.value.phone_number,
            "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((editForm.value.phone_number) = $event)),
            label: "Phone number"
          }, null, 8, ["modelValue"]),
          _createVNode(CommonDropdown, {
            modelValue: editForm.value.role,
            "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((editForm.value.role) = $event)),
            items: roleItems.value,
            label: "Role",
            fullWidth: true
          }, null, 8, ["modelValue", "items"]),
          _createVNode(CommonDropdown, {
            modelValue: editForm.value.team_id,
            "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((editForm.value.team_id) = $event)),
            items: teamItems.value,
            label: "Team",
            fullWidth: true
          }, null, 8, ["modelValue", "items"]),
          _createVNode(CommonDropdown, {
            modelValue: editForm.value.shift_template_id,
            "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((editForm.value.shift_template_id) = $event)),
            items: shiftItems.value,
            label: "Shift",
            fullWidth: true
          }, null, 8, ["modelValue", "items"]),
          _createVNode(CommonDropdown, {
            modelValue: editForm.value.default_day_off,
            "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((editForm.value.default_day_off) = $event)),
            items: dayOffItems,
            label: "Day off",
            fullWidth: true
          }, null, 8, ["modelValue"])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(CommonModal, {
      modelValue: passwordModal.value,
      "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((passwordModal).value = $event)),
      title: "Password change"
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_32, [
          _createVNode(CommonButton, {
            type: "outline",
            label: "Cancel",
            onClicked: closePasswordModal
          }),
          _createVNode(CommonButton, {
            "is-disabled": 
              !(password.value.length > 5) || password.value !== confirmPassword.value
            ,
            type: "primary",
            label: "Save",
            onClicked: savePasswordModal
          }, null, 8, ["is-disabled"])
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_31, [
          _createVNode(CommonInput, {
            type: "password",
            modelValue: password.value,
            "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((password).value = $event)),
            label: "New password"
          }, null, 8, ["modelValue"]),
          _createVNode(CommonInput, {
            type: "password",
            modelValue: confirmPassword.value,
            "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((confirmPassword).value = $event)),
            label: "Confirm password"
          }, null, 8, ["modelValue"])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})